import { Component } from "@angular/core";

// FIXME(https://bitwarden.atlassian.net/browse/CL-764): Migrate to OnPush
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: "bit-menu-divider",
  templateUrl: "./menu-divider.component.html",
})
export class MenuDividerComponent {}
